import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
const teamMembers = [{
  name: 'Thomas Dubois',
  role: 'CEO & Fondateur',
  bio: "Plus de 15 ans d'expérience dans le développement d'affaires en Afrique. Ancien directeur export pour un grand groupe français.",
  image: 'https://randomuser.me/api/portraits/men/32.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'thomas.dubois@elevateit.fr'
}, {
  name: 'Marie Laurent',
  role: 'Directrice des Opérations',
  bio: "Experte en gestion de projets internationaux avec une spécialisation sur les marchés d'Afrique de l'Ouest.",
  image: 'https://randomuser.me/api/portraits/women/44.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'marie.laurent@elevateit.fr'
}, {
  name: 'Abdoulaye Diallo',
  role: 'Responsable Partenariats Afrique',
  bio: "Basé à Dakar, il coordonne notre réseau de partenaires locaux dans 15 pays d'Afrique.",
  image: 'https://randomuser.me/api/portraits/men/68.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'abdoulaye.diallo@elevateit.fr'
}, {
  name: 'Sophie Moreau',
  role: 'Directrice Commerciale',
  bio: "Ancienne consultante chez Business France, spécialiste de l'accompagnement des PME françaises à l'international.",
  image: 'https://randomuser.me/api/portraits/women/65.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'sophie.moreau@elevateit.fr'
}, {
  name: 'Jean-Philippe Martin',
  role: 'Directeur Technique',
  bio: "Ingénieur de formation, il supervise le développement de notre plateforme et l'intégration des technologies d'IA.",
  image: 'https://randomuser.me/api/portraits/men/75.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'jp.martin@elevateit.fr'
}, {
  name: 'Aminata Touré',
  role: 'Analyste Marchés Publics',
  bio: "Experte en appels d'offres internationaux, elle dirige notre équipe d'analystes spécialisés par secteur d'activité.",
  image: 'https://randomuser.me/api/portraits/women/32.jpg',
  linkedin: '#',
  twitter: '#',
  email: 'aminata.toure@elevateit.fr'
}];
export function TeamPage() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-3931">
      <Navbar data-id="element-3932" />
      <main className="pt-20" data-id="element-3933">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20 relative overflow-hidden" data-id="element-3934">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-3935">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-3936">
              <defs data-id="element-3937">
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-3938">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-3939" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" data-id="element-3940" />
            </svg>
          </div>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-blue-800 rounded-full opacity-30 transform translate-x-1/3 -translate-y-1/3" data-id="element-3941"></div>
          <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/3 translate-y-1/3" data-id="element-3942"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-3943">
            <div className="max-w-3xl mx-auto text-center" data-id="element-3944">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-3945">
                Notre Équipe
              </h1>
              <p className="text-xl text-blue-100 mb-8" data-id="element-3946">
                Une équipe d'experts passionnés par l'Afrique et dédiés à votre
                réussite sur le continent.
              </p>
            </div>
          </div>
        </section>
        {/* Our Mission Section */}
        <section className="py-20 bg-blue-50" data-id="element-3947">
          <div className="container mx-auto px-4" data-id="element-3948">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-3949">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-3950">
                Notre Mission
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-3951">
                Connecter les entreprises françaises aux opportunités africaines
              </h2>
              <p className="text-lg text-gray-700" data-id="element-3952">
                Fondée en 2018, ElevateIT est née d'un constat simple : les
                entreprises françaises manquent souvent d'informations fiables
                et d'accompagnement pour saisir les nombreuses opportunités
                qu'offre le continent africain en plein essor.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-3953">
              <motion.div className="bg-white p-6 rounded-xl shadow-md" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-3954">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-3955">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3956">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3957" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-blue-900 mb-3" data-id="element-3958">
                  Expertise Locale
                </h3>
                <p className="text-gray-700" data-id="element-3959">
                  Notre équipe combine expertise française et connaissance
                  approfondie des marchés africains.
                </p>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-xl shadow-md" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} viewport={{
              once: true
            }} data-id="element-3960">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-3961">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3962">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-3963" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-blue-900 mb-3" data-id="element-3964">
                  Réseau Étendu
                </h3>
                <p className="text-gray-700" data-id="element-3965">
                  Un réseau de partenaires locaux dans plus de 30 pays africains
                  pour vous accompagner.
                </p>
              </motion.div>
              <motion.div className="bg-white p-6 rounded-xl shadow-md" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.4
            }} viewport={{
              once: true
            }} data-id="element-3966">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-3967">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3968">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-3969" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-blue-900 mb-3" data-id="element-3970">
                  Engagement Qualité
                </h3>
                <p className="text-gray-700" data-id="element-3971">
                  Des informations vérifiées et une approche personnalisée pour
                  chaque client.
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Team Members Section */}
        <section className="py-20" data-id="element-3972">
          <div className="container mx-auto px-4" data-id="element-3973">
            <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-3974">
              <span className="inline-block px-3 py-1 bg-blue-50 text-blue-900 text-sm font-semibold rounded-full mb-4" data-id="element-3975">
                Notre Équipe
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-3976">
                Les visages derrière ElevateIT
              </h2>
              <p className="text-lg text-gray-700" data-id="element-3977">
                Une équipe multiculturelle d'experts passionnés par l'Afrique et
                le développement des entreprises.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3978">
              {teamMembers.map((member, index) => <motion.div key={member.name} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 transition-transform hover:-translate-y-1" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} viewport={{
              once: true
            }} data-id="element-3979">
                  <div className="h-64 overflow-hidden" data-id="element-3980">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-3981" />
                  </div>
                  <div className="p-6" data-id="element-3982">
                    <h3 className="text-xl font-bold text-blue-900" data-id="element-3983">
                      {member.name}
                    </h3>
                    <p className="text-yellow-600 font-medium mb-3" data-id="element-3984">
                      {member.role}
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-3985">{member.bio}</p>
                    <div className="flex space-x-3" data-id="element-3986">
                      <a href={member.linkedin} className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 hover:bg-blue-200 transition-colors" data-id="element-3987">
                        <LinkedinIcon size={16} data-id="element-3988" />
                      </a>
                      <a href={member.twitter} className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 hover:bg-blue-200 transition-colors" data-id="element-3989">
                        <TwitterIcon size={16} data-id="element-3990" />
                      </a>
                      <a href={`mailto:${member.email}`} className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 hover:bg-blue-200 transition-colors" data-id="element-3991">
                        <MailIcon size={16} data-id="element-3992" />
                      </a>
                    </div>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>
        {/* Join Our Team Section */}
        <section className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-3993">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-3994">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-3995">
              <defs data-id="element-3996">
                <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-3997">
                  <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" data-id="element-3998" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#smallGrid)" data-id="element-3999" />
            </svg>
          </div>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-800 rounded-full opacity-50 transform translate-x-1/3 -translate-y-1/3" data-id="element-4000"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/3 translate-y-1/3" data-id="element-4001"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-4002">
            <div className="max-w-3xl mx-auto text-center" data-id="element-4003">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-4004">
                Rejoignez notre équipe
              </h2>
              <p className="text-xl text-blue-100 mb-8" data-id="element-4005">
                Vous êtes passionné(e) par l'Afrique et l'innovation ? Nous
                sommes toujours à la recherche de talents pour renforcer notre
                équipe.
              </p>
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20" data-id="element-4006">
                Voir nos offres d'emploi
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-4007" />
    </div>;
}